import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url,attendanceserver} from '@/utils/baseUrl';


// 同步南北
export async function saveSNUser(params) {
    return post(oaserver+'/api/snmasterData/sn/saveSNUser', params, true)
}
// 同步用友
export async function saveUser(params) {
    return post(oaserver+'/api/masterData/yy/saveUser', params, true)
}
//部门树
export async function getDeptTree(params) {
    return post(oaserver+'/organize/getDeptTree', params, true)
}
export async function getUserList(params) {
    return post(oaserver+'/organize/getUserList', params, true)
}
export async function getUserDetail(params) {
    return post(oaserver+'/organize/getUserDetail', params, true)
}
//区域树
export async function getAreaTree(params) {
    return post(oaserver+'/dict/area/getAreaTree', params, true);
}
//公司列表
export async function getCompanyList(params) {
    return post(oaserver+'/organize/getCompanyList', params, true);
}
//人员类别
export async function getUserTypeList(params) {
    return post(oaserver+'/organize/getUserTypeList', params, true);
}
//人员职级
export async function getUserHeadShip(params) {
    return post(oaserver+'/organize/getUserHeadShip', params, true);
}
//人员班次
export async function getUserClass(params) {
    return post(oaserver+'/organize/getUserClass', params, true);
}
//OA登录名校验
export async function validateLoginName(params) {
    return post(oaserver+'/organize/validateLoginName', params, true);
}

//编辑
export async function editUser(params) {
    return post(oaserver+'/organize/editUser', params, true);
}
//新增
export async function addUser(params) {
    return post(oaserver+'/organize/addUser', params, true);
}
//新增人员异动
export async function addUserDeptRelation(params) {
    return post(oaserver+'/organize/addUserDeptRelation', params, true);
}
//人员异动
export async function getUserDeptRelations(params) {
    return post(oaserver+'/organize/getUserDeptRelations', params, true);
}

//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}